import React, { ReactNode } from 'react'

import { Portal } from 'components/Dialog/Portal'
import withCondition from 'components/withCondition'
import { useClickOutside } from 'utils/hooks/useClickOutside'
import { useLockScroll } from 'utils/hooks/useScrollLock'

import { DialogVariant } from '../../types'
import { StyledContainer, StyledContainerBackground, StyledOverlay, StyledOverlayBackground } from './styles'

interface DialogContainerProps {
  variant: DialogVariant
  children: ReactNode
  close?: () => void
  className?: string
}

function DialogContainerComponent({ children, variant, className, close = () => null }: DialogContainerProps) {
  const ref = useClickOutside(close)
  useLockScroll()

  return (
    <Portal>
      <StyledOverlay className={className}>
        <StyledOverlayBackground
          onClick={(event) => {
            event.stopPropagation()
          }}
        />
        <StyledContainer
          ref={ref}
          onClick={(event) => {
            event.stopPropagation()
          }}
          variant={variant}
        >
          {children}
          <StyledContainerBackground
            variant={variant}
            brightness={1.2}
            blur={2}
            saturate={0.5}
          />
        </StyledContainer>
      </StyledOverlay>
    </Portal>
  )
}

export const DialogContainer = withCondition(DialogContainerComponent)
